// extracted by mini-css-extract-plugin
export default {"root":"tweet-link_root__T-82F"};